"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  &::after {\n    position: absolute;\n    inset: 0;\n    display: block;\n    content: '';\n    border-radius: ", ";\n    background: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  background: ", ";\n  width: ", ";\n  height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonText = exports.Skeleton = void 0;

var web_1 = require("@thesisedu/web");

var react_1 = __importDefault(require("react"));

var theme_1 = require("../theme");

exports.Skeleton = web_1.styled.div(_templateObject(), function (props) {
  return (0, theme_1.getSize)(props.theme, '@border-radius-base');
}, function (props) {
  return (0, theme_1.getColor)(props.theme, '@gray-1');
}, function (props) {
  return props.fill ? '100%' : 'auto';
}, function (props) {
  return props.fill ? '100%' : 'auto';
});
var MIN_LENGTH = 10;
var MAX_LENGTH = 20;

function getRandomChildren() {
  var length = Math.random() * (MAX_LENGTH - MIN_LENGTH) + MIN_LENGTH;
  return 'a'.repeat(length);
}

function SkeletonText(_a) {
  var _children = _a.children,
      rest = __rest(_a, ["children"]);

  var randomChildren = react_1.default.useRef(getRandomChildren()).current;
  var children = _children || randomChildren;
  return react_1.default.createElement(SkeletonTextOuter, Object.assign({}, rest), react_1.default.createElement(SkeletonTextContainer, {
    children: children
  }));
}

exports.SkeletonText = SkeletonText;
var SkeletonTextOuter = web_1.styled.div(_templateObject2());
var SkeletonTextContainer = web_1.styled.span(_templateObject3(), function (props) {
  return (0, theme_1.getSize)(props.theme, '@border-radius-base');
}, function (props) {
  return (0, theme_1.getColor)(props.theme, '@gray-1');
});